/** @jsx jsx */
import { Box, Flex, Heading, Paragraph } from "@eworkit/iris";
import React, { FC } from "react";
import { jsx } from "theme-ui";

interface BannerProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  button?: React.ReactNode;
}

export const Banner: FC<BannerProps> = ({ title, description, icon, button }) => {
  return (
    <Box backgroundColor="vg900" borderRadius="lg" p="md">
      <Flex
        alignItems={[null, null, null, "center"]}
        justifyContent="flex-start"
        flexDirection={["column", null, null, "row"]}
        gap="md">
        <Flex flexGrow={1} gap="md">
          <div sx={{ "[data-icon]": { color: "n0", fontSize: "40px" } }}>{icon}</div>
          <Flex flexDirection="column" gap="xs">
            <Heading size="h-xs" color="n0">
              {title}
            </Heading>
            <Flex>
              <Paragraph size="p-md" color="n0">
                {description}
              </Paragraph>
            </Flex>
          </Flex>
        </Flex>

        {button && <Flex flexDirection="column">{button}</Flex>}
      </Flex>
    </Box>
  );
};
